const TextAreaField = ({ name, value, onChange, disabled }) => {
  return (
    <textarea
      className="form-control"
      style={{
        minWidth: "120px",
        // width: "120px", // All cells same width
        height: "28px", // Excel-like height
        padding: "2px 6px",
        margin: 0,
        borderRadius: 0,
        fontSize: "13px",
        boxSizing: "border-box",
      }}
      rows={4}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(name, e.target.value)}
    />
  );
};

export default TextAreaField;
